module.exports = __webpack_public_path__ + "static/media/breastSurgery-image3.33cf1719.png";